import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { Button } from '../components/Button';
import { Check, Shield, Lock } from 'lucide-react';
export function Donate() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://donorbox.org/widgets.js';
    script.type = 'module';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <div className="pt-20" data-id="element-161">
      {/* Hero */}
      <section className="bg-[var(--color-text)] text-white py-20" data-id="element-162">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-163">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-164">
            <h1 className="text-white mb-6" data-id="element-165">
              Give Life. Give Light. Give Hope.
            </h1>
            <p className="text-lg md:text-xl text-white/90" data-id="element-166">
              Your generosity transforms communities and changes lives forever.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Donation Form */}
      <section className="relative py-20" data-id="element-167">
        {/* Background Image */}
        <div className="absolute inset-0 z-0" data-id="element-168">
          <img src="https://cdn.magicpatterns.com/uploads/moVvPjCp8t48hMkVnhpREn/2025_08_BLF_era92Creative_05326.jpg" alt="Community gathering for clean water" className="w-full h-full object-cover" data-id="element-169" />
          <div className="absolute inset-0 bg-black/60" data-id="element-170"></div>
        </div>

        <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-172">
            {/* Impact Text */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="text-white" data-id="element-173">
              <h2 className="text-white mb-6 text-3xl md:text-4xl" data-id="element-174">
                Kingdom News
              </h2>
              <p className="text-lg md:text-xl text-white/90 leading-relaxed mb-6" data-id="element-175">
                Your generosity doesn't just fund projects—it transforms
                communities.
              </p>
              <div className="space-y-6" data-id="element-176">
                <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg border border-white/20" data-id="element-177">
                  <p className="text-white leading-relaxed font-medium" data-id="element-178">
                    "Nearly more than three dozen people were baptized inside of
                    the first six months after the water well was installed.
                    Lives have already been spared and saved at the hospital due
                    to access to clean electricity."
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Donorbox Widget */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} data-id="element-179">
              <div className="bg-white rounded-lg shadow-2xl overflow-hidden p-4 sm:p-8 max-w-lg mx-auto lg:mx-0 lg:ml-auto" data-id="element-180">
                <div className="w-full min-h-[600px] flex justify-center" data-id="element-181">
                  {/* @ts-ignore - Custom element */}
                  <dbox-widget campaign="big-love-foundation" type="donation_form" enable-auto-scroll="true" data-id="element-182"></dbox-widget>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Impact Section */}
      <section className="py-20 bg-white" data-id="element-183">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-185">
            <h2 className="text-[var(--color-text)] mb-4" data-id="element-186">Your Impact</h2>
            <p className="text-lg text-[var(--color-text-light)]" data-id="element-187">
              See exactly how your donation creates transformation.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-188">
            {[{
            amount: '$50',
            impact: 'Supports community outreach and essential discipleship resources'
          }, {
            amount: '$100',
            impact: 'Helps bring clean, safe water to families and communities in need'
          }, {
            amount: '$250',
            impact: 'Contributes to sustainable solar power for critical facilities'
          }, {
            amount: '$500+',
            impact: 'Creates lasting transformation through major community infrastructure projects'
          }].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="bg-[var(--color-gray-light)] rounded-lg p-6 text-center" data-id="element-189">
                <div className="text-3xl font-bold text-[var(--color-primary)] mb-3" data-id="element-190">
                  {item.amount}
                </div>
                <p className="text-[var(--color-text-light)] leading-relaxed" data-id="element-191">
                  {item.impact}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>
    </div>;
}